import { render, staticRenderFns } from "./fenzu_detail.vue?vue&type=template&id=c8b7af06&scoped=true&"
import script from "./fenzu_detail.vue?vue&type=script&lang=js&"
export * from "./fenzu_detail.vue?vue&type=script&lang=js&"
import style0 from "./fenzu_detail.vue?vue&type=style&index=0&id=c8b7af06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b7af06",
  null
  
)

export default component.exports